import React from 'react';
import { AlertProvider } from 'acma-spa';
import { Link } from '../../common/FormHelpers';
import { ClientApiProps } from '../../../client/common/ClientApiProps';

const wrapperStyle: React.CSSProperties = { display: 'inline-flex', flexDirection: 'column', gap: '1rem' };

/**
 * NOTE: Wrap everything in an inline-flex. It behaves just like a series of "p" tags, without breaking HTML strict guidelines.
 * We can't use "p" tags because the AlertProvider already wraps everything in a "p" tag. A "p" tag can not wrap a block-level element.
 */
export function PrivacyDeclaration(props: ClientApiProps): JSX.Element {
  const msg = (
    <span style={wrapperStyle}>
      <span>
        If you would like to apply for an ACMA recognition certificate, you will need to provide the information requested in the form, including your name,
        date of birth, contact details, information about your qualifications and any amateur radio examinations you have completed. The ACMA will not be able
        to issue you an ACMA recognition certificate until you provide this information. The personal information being collected in this form is to confirm
        that you have the adequate qualifications to be issued with an ACMA recognition certificate. The ACMA will also use the information to administer call
        signs and facilitate call sign applications and assignments.
      </span>
      <span>
        The ACMA publishes a call sign register on its website that lists all call signs and, if the call sign is allocated, the respective qualification
        levels associated with that allocated call sign. The call sign register does not contain any other information about a licence holder.
      </span>
      <span>
        The ACMA will not use any of the personal information you provide in this form for any other purpose, nor will we disclose it, unless we have your
        consent or we are otherwise permitted to do so under the <em>Privacy Act 1988</em>.
      </span>
      <span>
        Further information about the {Link(props.contentUrls.privacyPolicy, "Privacy Act and the ACMA's Privacy Policy")} is on our website. The
        Privacy Policy contains details about how you may access personal information about you that is held by the ACMA, and seek the correction of such
        information. It also explains how you may complain about a breach of the {Link(props.contentUrls.privacyAct, 'Privacy Act')} and how we will deal with
        such a complaint.
      </span>
    </span>
  );

  return <AlertProvider title="Privacy" color="info" messages={[msg]} />;
}
